// extracted by mini-css-extract-plugin
module.exports = {"dropShadow":"dropshadow_dropShadow__3Rn25"};